import { render, staticRenderFns } from "./ItinerarioDayList.vue?vue&type=template&id=6c13441b&scoped=true"
import script from "./ItinerarioDayList.vue?vue&type=script&lang=js"
export * from "./ItinerarioDayList.vue?vue&type=script&lang=js"
import style0 from "./ItinerarioDayList.vue?vue&type=style&index=0&id=6c13441b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c13441b",
  null
  
)

export default component.exports